import React from 'react'
import './NewHackathon.scss'

const NewHackathon = () => {
  return (
    <div>NewHackathon</div>
  )
}

export default NewHackathon